export enum SortMethods {
  ByFeatured = "updatedAt_DESC",
  ByPriceAsc = "price_ASC",
  ByPriceDesc = "price_DESC",
  ByNameAsc = "productName_ASC",
  ByNameDesc = "productName_DESC",
}
